import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import { Actions, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import {
  GET_INTEGRATION_IMPORTS_FAILURE,
  GET_INTEGRATION_IMPORTS_SUCCESS,
  GetIntegrationImportsAction
} from './integration-imports.actions';
import { DefaultIntegrationImportParams } from './integration-imports.interface';
import { IState } from '../../shared/models/state';

@Injectable()
export class IntegrationImportsResolve implements Resolve<any> {
  constructor(private store: Store<IState>, private action$: Actions) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.store.dispatch(new GetIntegrationImportsAction({}));
    return this.action$.pipe(
      ofType(GET_INTEGRATION_IMPORTS_SUCCESS, GET_INTEGRATION_IMPORTS_FAILURE),
      map((action: any) => {
        return action.payload;
      }),
      take(1)
    );
  }
}
